import api from './axiosInstance';

// Outlook endpoints
export const getConnectUrl = {
  getConnectUrl: async () => {
    try {
      const response = await api.get(`/outlook/connect/url`, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
      return response.data;
    } catch (error) {
      error.customMessage =
        'No se pudo conectar con Outlook. Intenta nuevamente';
      throw error;
    }
  },
};

export const getConnectionStatus = {
  getStatus: async () => {
    try {
      const response = await api.get(`/outlook/status`, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
      return response.data;
    } catch (error) {
      error.customMessage =
        'No se pudo obtener el estado de la conexión con Outlook. Intenta nuevamente';
      throw error;
    }
  },
};

export const postDisconnect = {
  postDisconnect: async () => {
    try {
      const response = await api.post(
        '/outlook/disconnect',
        {},
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );

      return response.data;
    } catch (error) {
      error.customMessage =
        'No se pudo desconectar de Outlook. Intenta nuevamente.';
      throw error;
    }
  },
};

// Appointment endpoints
export const postCreateAppointment = {
  create: async (payload) => {
    try {
      const response = await api.post('/Appointment', payload);
      return response.data;
    } catch (error) {
      error.customMessage = 'No se pudo crear la reunión. Intenta nuevamente.';
      throw error;
    }
  },
};

export const getAppointmentPaged = {
  getPaged: async (
    page,
    pageSize,
    search,
    userId,
    sortBy = 'StartAtUtc',
    desc = true,
    fromUtc,
    toUtc,
    origin
  ) => {
    try {
      const response = await api.get('/Appointment/paged', {
        params: {
          page,
          pageSize,
          search: search || null,
          userId: userId || null,
          sortBy,
          desc,
          onlyActive: true,
          fromUtc: fromUtc || null,
          toUtc: toUtc || null,
          origin: origin === 'all' ? null : origin,
        },
      });

      return response.data;
    } catch (error) {
      error.customMessage =
        'No se pudo obtener el listado de reuniones. Intenta nuevamente.';
      throw error;
    }
  },
};

export const getAppointmentRange = {
  getRange: async ({
    fromUtc = null,
    toUtc = null,
    meetingTypeId = null,
    appointmentStatusId = null,
    onlyActive = true,
  }) => {
    try {
      const response = await api.get('/Appointment/range', {
        params: {
          fromUtc,
          toUtc,
          meetingTypeId,
          appointmentStatusId,
          onlyActive,
        },
      });

      return response.data;
    } catch (error) {
      error.customMessage =
        'No se pudo obtener las reuniones del calendario. Intenta nuevamente.';
      throw error;
    }
  },
};

export const getAppointmentById = {
  getAppointment: async (id) => {
    try {
      const response = await api.get(`/Appointment/${id}`);
      return response.data;
    } catch (error) {
      error.customMessage = 'No se pudo obtener el evento. Intenta nuevamente.';
      throw error;
    }
  },
};

export const putUpdateAppointment = {
  putUpdate: async (id, payload) => {
    try {
      const response = await api.put(`/Appointment/${id}`, payload);
      return response.data;
    } catch (error) {
      error.customMessage =
        'No se pudo actualizar el evento. Intenta nuevamente.';
      throw error;
    }
  },
};

export const softDeleteAppointment = {
  deleteAppointment: async (id) => {
    try {
      const response = await api.delete(`/Appointment/${id}`);
      return response.data;
    } catch (error) {
      error.customMessage =
        'No se pudo eliminar el evento. Intenta nuevamente.';
      throw error;
    }
  },
};
